import styled from 'styled-components';
import { CommunityRemovalStatus } from '../../../common/enums/CommunityRemovalStatus';

const statusColors = {
  [CommunityRemovalStatus.Completed]: '#1c6c1f',
  [CommunityRemovalStatus.InProgress]: '#8a6d00',
  [CommunityRemovalStatus.Fail]: '#a50f15',
  [CommunityRemovalStatus.Scheduled]: '#003d8b'
};

export const StatusText = styled.span<{ status: CommunityRemovalStatus }>`
  font-weight: bold;
  color: ${({ status }) => statusColors[status] || '#000'};
`;

export const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const ButtonContainer = styled.span`
  margin-left: 10px;
`;
